import { Grid, Typography } from "@mui/material";

import { Paper } from "../../../components";
import { colors } from "../../css components/Style";

export default function CampaignStatus({ formikProps }) {
  return (
    <Paper>
      <Grid item xs={12}>
        <Typography
          style={{
            fontSize: "15px",
            color: colorPicker(formikProps.values.requestStatus),
          }}
        >
          Approval Status -{" "}
          {formikProps.values?.requestStatus?.replace(/_/g, " ")}
        </Typography>
        <Typography
          style={{
            fontSize: "15px",
            color: colorPicker(formikProps.values.campaignStatus),
          }}
        >
          Campaign Status -{" "}
          {formikProps.values?.campaignStatus?.replace(/_/g, " ")}
        </Typography>
      </Grid>
    </Paper>
  );

  function colorPicker(status) {
    let color;

    if (status === "REQUESTED" || status === "CREATED") {
      color = colors.yellow;
    }

    if (
      status === "OFFER_ACCEPTED" ||
      status === "ACCEPTED" ||
      status === "ACTIVE"
    ) {
      color = colors.green;
    }

    if (status === "PARTIAL_ACCEPTED") {
      color = colors.success;
    }

    if (status === "INITIATED") {
      color = colors?.purple;
    }

    if (
      status === "REJECTED" ||
      status === "Expired" ||
      status === "FAILED" ||
      status === "MISSED" ||
      status === "PARTIAL_REJECTED"
    ) {
      color = colors.error;
    }

    if (status === "READY") {
      color = colors.success;
    }

    return color;
  }
}
